<!--姓名/医院登录弹框-->
<template>
  <div class="name-hospital-login-container">
    <!-- 登录弹框 -->
    <van-dialog
      v-model="loginShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'300px'"
    >
      <template #default>
        <div v-if="isPc" class="login-content-pc">
          <div class="title">{{content.loginIn}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <el-form class="maxHeight70 login-form-p beauty-scroll">
            <el-form-item :label="content.loginNameLabel">
              <el-input
                v-model="loginForm.name"
                :maxlength="15"
                :placeholder="content.loginNameTip">
              </el-input>
            </el-form-item>
            <el-form-item :label="content.loginCompanyLabel">
              <el-input
                v-model="loginForm.hospital_name"
                :maxlength="30"
                :placeholder="content.loginCompanyTip">
              </el-input>
            </el-form-item>
            <el-form-item :label="content.loginOfficeLabel">
              <el-input
                v-model="loginForm.hospital_office"
                :maxlength="30"
                :placeholder="content.loginOfficeTip">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="policy-check">
            <van-checkbox
              v-model="policyCheck"
              icon-size="0.18rem"
            >{{content.hasRead}}《
            <span class="policy-link" @click.stop="lookPolicy">{{content.policy}}</span>
            》</van-checkbox>
          </div>
          <van-button
            type="info"
            round
            class="loginBtn"
            :disabled="!(loginForm.name&&loginForm.hospital_name&&loginForm.hospital_office&&policyCheck)"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="loginBtn"
          >{{content.loginIn}}</van-button>
        </div>
        <div v-else class="login-content">
          <div class="title">{{content.loginIn}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <van-field
            v-model="loginForm.name"
            size="small"
            maxlength="15"
            :placeholder="content.loginNameTip"
          />
          <van-field
            v-model="loginForm.hospital_name"
            size="small"
            maxlength="30"
            :placeholder="content.loginCompanyTip"
          />
          <van-field
            v-model="loginForm.hospital_office"
            size="small"
            maxlength="30"
            :placeholder="content.loginOfficeTip"
          />
          <div class="policy-check">
            <van-checkbox
              v-model="policyCheck"
              icon-size="0.18rem"
            >{{content.hasRead}}《
            <span class="policy-link" @click.stop="lookPolicy">{{content.policy}}</span>
            》</van-checkbox>
          </div>
          <van-button
            type="info"
            round
            class="loginBtn"
            :disabled="!(loginForm.name&&loginForm.hospital_name&&loginForm.hospital_office&&policyCheck)"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="loginBtn"
          >{{content.loginIn}}</van-button>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { postAddMember } from '@/models/common'

export default {
  props:{
    streamId:{
      type: Number,
      default: -1
    },
    conventionId:{
      type: Number,
      default: -1
    },
    canClose: {
      // 是否允许关闭
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      loginShow: false, // 登录弹框
      loginForm: { // 登录框表单
        name: '',
        hospital_name: '', // 医院
        hospital_office: '', // 科室
        job_title: '', // 职称
      },
      policyCheck: false, // 同意协议
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  methods:{
    // 关闭弹窗
    closeDialog() {
      this.loginShow = false
    },
    // 弹框
    showDialog(){
      this.loginShow = true
    },
    // 查看隐私协议
    lookPolicy(){
      this.$emit('lookPolicy')
    },
    // 登录按钮
    loginBtn() {
      const _this = this
      if (String(this.loginForm.name).trim() && String(this.loginForm.hospital_name).trim() && String(this.loginForm.hospital_office).trim() && this.policyCheck) {
        postAddMember({
          stream_id: this.streamId,
          name: String(this.loginForm.name).trim(),
          hospital_name: String(this.loginForm.hospital_name).trim(),
          hospital_office: String(this.loginForm.hospital_office).trim(),
          convention_id: this.conventionId != -1 ? this.conventionId : null
        }).then(res => {
          // console.log(res)

          let rooms = localStorage.getItem('x_room') ? JSON.parse(localStorage.getItem('x_room')) : []
          rooms.push(Number(_this.streamId))
          localStorage.setItem('x_room', JSON.stringify(rooms))

          _this.$toast(_this.content.loginSuccess)
          _this.loginShow = false
          this.$emit('loginSuccess')
          // if (res.data.code == 0) {
          //   localStorage.setItem('x_room', res.data.data.token)
            
          //   _this.$toast('登录成功')
          //   _this.loginShow = false
          //   this.$emit('loginSuccess', {id: res.data.data.id, phone: _this.loginForm.phone})
          // } else {
          //   _this.$toast('登录失败')
          //   this.$emit('loginFail')
          // }
        })
      } else if(!this.policyCheck){
        this.$toast(this.content.needCheckPolicy)
      } else {
        this.$toast(this.content.hospitalLoginValidFail)
      }
    },
  }
}
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.van-dialog {
  border-radius: 6px;
}
.name-hospital-login-container{
  .login-content-pc {
    // height: 3.45rem;
    padding: 0 0.35rem;
    .login-form-p{
      padding: 0 0.4rem;
    }
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.1rem;
    }
    .close-icon {
      position: absolute;
      top: 0.33rem;
      right: 0.3rem;
      cursor: pointer;
    }
    .van-cell {
      margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .policy-check{
      margin-top: 0.1rem;
      .policy-link{
        color: #2284E5;
      }
      /deep/.van-checkbox__label {
        font-size: 0.17rem;
      }
      /deep/.van-icon{
        line-height: 1;
      }
    }
    .loginBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.2rem auto 0.2rem;
      display: block;
    }
  }
  .login-content {
    // height: 3.45rem;
    padding: 0 0.25rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.2rem;
    }
    .close-icon {
      position: absolute;
      top: 0.23rem;
      right: 0.23rem;
      cursor: pointer;
    }
    .van-cell {
      margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .policy-check{
      margin-top: 0.1rem;
      .policy-link{
        color: #2284E5;
      }
      /deep/.van-checkbox__label {
        font-size: 0.16rem;
      }
    }
    .loginBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.2rem auto 0.3rem;
      display: block;
    }
  }
}
</style>